import { ScrollView } from "devextreme-react";
import { useTranslation } from "react-i18next";
import { MyPresence } from "../presence/components/MyPresence";
import { ViewSwitchProvider } from "../presence/contexts/ViewSwitchContext";
import "./Calendar.scss";

export const CalendarWork = () => {
  const { t } = useTranslation();

  return (
    <ScrollView useNative>
      <div className="p-6">
        <div className="mb-6">
          <div className="mb-2 text-2xl font-bold leading-none">
            {t("Calendar")}
          </div>
          <div className="text-base">{t("calendar.headerText")}</div>
        </div>
        <ViewSwitchProvider>
          <MyPresence />
        </ViewSwitchProvider>
      </div>
    </ScrollView>
  );
};
